import React, { useState, useEffect, useRef } from "react";
import { X } from "lucide-react";
import { Button } from "../ui/button";
import PerfilEmpresaPage from "../../pages/user/EmpresaPage";
import ImportarEquipos from "../../pages/config/ImportPage";
import PerfilUsuarioPage from "../../pages/user/InformacionPage";

const STEP_LABELS = {
  empresa: "Empresa",
  import: "Importar inventario",
  perfil: "Tu perfil",
};

const STEP_COMPONENTS = {
  empresa: PerfilEmpresaPage,
  import: ImportarEquipos,
  perfil: PerfilUsuarioPage,
};

const OnboardingWizardModal = ({
  open,
  initialStep,
  applicableSteps,
  onClose,
  onStepDone,
}) => {
  const [stepIndex, setStepIndex] = useState(0);
  const wasOpen = useRef(false);

  useEffect(() => {
    if (open && !wasOpen.current) {
      const idx = applicableSteps.indexOf(initialStep);
      setStepIndex(idx >= 0 ? idx : 0);
    }
    wasOpen.current = open;
  }, [open, initialStep, applicableSteps]);

  if (!open) return null;

  const stepKey = applicableSteps[stepIndex];
  const StepComponent = STEP_COMPONENTS[stepKey];
  const isLastStep = stepIndex === applicableSteps.length - 1;

  // "Omitir" y "Siguiente" hacen exactamente lo mismo: cada paso ya tiene su
  // propio botón de guardado interno (PerfilEmpresaPage/InformacionPage), así
  // que avanzar el wizard nunca implica guardar por sí solo — es intencional,
  // no un descuido. Ver docs/superpowers/specs/2026-07-14-onboarding-wizard-tour-design.md.
  const advance = () => {
    onStepDone(stepKey);
    if (isLastStep) {
      onClose();
    } else {
      setStepIndex((i) => i + 1);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
          <div>
            <p className="text-xs text-gray-400">
              Paso {stepIndex + 1} de {applicableSteps.length}
            </p>
            <h2 className="text-lg font-semibold text-gray-800">
              {STEP_LABELS[stepKey]}
            </h2>
          </div>
          <button
            onClick={onClose}
            className="p-1.5 rounded-lg text-gray-400 hover:bg-gray-100 hover:text-gray-600"
            aria-label="Cerrar"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="p-6">
          <StepComponent />
        </div>

        <div className="flex items-center justify-between px-6 py-4 border-t border-gray-100">
          <Button variant="outline" onClick={advance}>
            Omitir este paso
          </Button>
          <Button onClick={advance}>
            {isLastStep ? "Finalizar" : "Siguiente →"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default OnboardingWizardModal;
